export default {
  EBS_SKIN_0: 'black',
  EBS_SKIN_1: 'latina',
  EBS_SKIN_2: 'oriental'
};
